import { getThemeColor, Styles } from "@mcleod/core";

export const ImageBundleCaptureStyles = Styles.make("image-bundle-capture", () => {
    return {
        captureContainer: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "16px",
            boxSizing: "border-box"
        },
        emptyState: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "32px",
            textAlign: "center",
            color: getThemeColor("subtle.dark")
        },
        emptyIcon: {
            marginBottom: "16px",
            opacity: 0.5
        },
        emptyText: {
            fontSize: "16px",
            marginBottom: "8px"
        },
        emptySubtext: {
            fontSize: "14px",
            color: getThemeColor("subtle.light")
        }
    };
});


